// IMPORTACION DE LIBRERIAS DESDE NODE

/* JQUERY */
var $ = require( "jquery" );

import {createPopper} from '@popperjs/core';
import {bootstrap} from 'bootstrap-front';

import header from './js/header.js';
header();

// COMPONENTES

import swiperCarousel from './js/swiper_carousels.js';
swiperCarousel();

import input from './js/input.js';
input();

import slider_bootstrap from './js/slider_bootstrap.js';
slider_bootstrap();

import cart from './js/cart.js';
cart();

$('.icons').load('/frontend/svg/sprite-images.svg');

import datePicker from './js/datepicker.js';
if( $('.datepicker').length ){ datePicker() };

import timePicker from './js/timepicker.js';
if( $('.timepicker').length ){ timePicker() };

import cantine from './js/cantine.js';
cantine();

import './js/wphack.js';
import './js/data-mytoastr.js';
